import { Card, CardContent } from "@/components/ui/card";
import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { TopicSelect } from "./TopicSelect";
import { MailActions } from "./MailActions";
import { WorkStateBadge, TargetLink, fmtMailDate } from "./MailDetail";

export function EmailRow({ email: e, onChanged, showTarget = false }) {
  const { user } = useAuth();
  const sent = e.folder === "sent";
  const people = sent ? (e.to || []).map((r) => r.name || r.email).join(", ") : e.from_name || e.from_email;

  return (
    <Card className="transition-shadow hover:shadow-md" data-testid={`mail-row-${e.id}`}>
      <CardContent className="py-3 flex items-start gap-3">
        <div className={`mt-0.5 w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${sent ? "bg-sky-50 text-sky-600" : "bg-[#FFF5EC] text-[#E8700A]"}`} title={sent ? "Gesendet" : "Eingang"}>
          {sent ? <ArrowUpRight className="w-4 h-4" /> : <ArrowDownLeft className="w-4 h-4" />}
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <div className="flex flex-wrap items-baseline gap-x-2">
            <span className="font-medium truncate max-w-full">{e.subject}</span>
            <span className="text-xs text-muted-foreground">{fmtMailDate(e.received_at)}</span>
          </div>
          <p className="text-sm text-muted-foreground truncate">{sent ? "An: " : "Von: "}{people}{!sent && e.from_name ? ` <${e.from_email}>` : ""}</p>
          {e.excerpt && <p className="text-sm line-clamp-2 text-slate-700">{e.excerpt}</p>}
          <div className="flex flex-wrap items-center gap-2 pt-0.5">
            <TopicSelect email={e} canEdit={user?.role !== "readonly"} onChanged={onChanged} />
            {showTarget && <TargetLink e={e} />}
            <WorkStateBadge e={e} />
          </div>
          <div className="pt-2"><MailActions email={e} onChanged={onChanged} /></div>
        </div>
      </CardContent>
    </Card>
  );
}
